export const BASE_PATH_WITH_TXA = `/account/:txaId`;

export const routeListViewFragments = {
  INVOICES: 'invoices',
  REFUNDS: 'refunds',
  SUBSCRIPTIONS: 'subscriptions',
  CUSTOMER_ADDRESSES: 'customer-addresses',
};

export const routeWithNoListViewFragments = {
  CLOUD_SITE_PATH: 'cloud-sites',
  BILLING_PROFILES: 'billing-profiles',
};

export const routeFragments = {
  ...routeListViewFragments,
  ...routeWithNoListViewFragments,
  DETAILS: 'details',
  CATALOGUE: 'catalogue',
  SEARCH: 'search',
  DETAILS_ACCOUNT_BALANCE: 'details/account-balance',
};

export const routePaths: { [key: string]: string } = {
  home: `${BASE_PATH_WITH_TXA}`,
  details: `${BASE_PATH_WITH_TXA}/${routeFragments.DETAILS}/`,
  accountBalance: `${BASE_PATH_WITH_TXA}/${routeFragments.DETAILS_ACCOUNT_BALANCE}`,
  invoices: `${BASE_PATH_WITH_TXA}/${routeFragments.INVOICES}/`,
  invoiceDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.INVOICES}/:invoiceId`,
  refunds: `${BASE_PATH_WITH_TXA}/${routeFragments.REFUNDS}/`,
  refundDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.REFUNDS}/:refundId`,
  subscriptions: `${BASE_PATH_WITH_TXA}/${routeFragments.SUBSCRIPTIONS}/`,
  entitlement: `${BASE_PATH_WITH_TXA}/${routeFragments.SUBSCRIPTIONS}/:entitlementId`,
  catalogue: `${BASE_PATH_WITH_TXA}/${routeFragments.CATALOGUE}/`,
  search: `${BASE_PATH_WITH_TXA}/${routeFragments.SEARCH}`,
  customerAddresses: `${BASE_PATH_WITH_TXA}/${routeFragments.CUSTOMER_ADDRESSES}`,
  customerAddressDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.CUSTOMER_ADDRESSES}/:addressId`,
  billingProfileDetails: `${BASE_PATH_WITH_TXA}/${routeFragments.BILLING_PROFILES}/:billingProfileId`,
  cloudSite: `${BASE_PATH_WITH_TXA}/${routeFragments.CLOUD_SITE_PATH}/:cloudSiteId`,
};

export const DEFAULT_PAGE_ROUTE = routePaths.home;
